import { scaleUtc } from '@visx/vendor/d3-scale';
import scaleOperator from "../operators/scaleOperator.js";
export const updateUtcScale = scaleOperator('domain', 'range', 'reverse', 'clamp', 'interpolate', 'nice', 'round');
export default function createUtcScale(config) {
  return updateUtcScale(scaleUtc(), config);
}